
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(2233|2954|3726)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
